export type ChangeLog ={
    id: string;
    externalId: string;
    updatedBy: string;
    updatedByName: string;
    type: ChangeLogType;
    changes: string;
    dateCreated: string;
    isDeletionLog: boolean;
}

export enum ChangeLogType {
   Project = 0, Station = 1, Client = 2, User = 3, Feedback = 4
}

export type DeletionLog = {
    id: string;
    externalId: string;
    deletedByName: string;
    type: ChangeLogType;
    name: string;
    dateDeleted: string;
}